import { Spinner } from "reactstrap";

const SpinnerAvantsolar = () => {
  return (
    <div className="d-flex justify-content-center my-3">
      <Spinner color="dark"> </Spinner>
    </div>
  );
};

export default SpinnerAvantsolar;
